import './Login.css';
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { loginPropThunk } from '../../redux/reducer/propSlice';
import { withErrorHandler } from '../../utils/utils';
import { LoginData, loginSchema } from '../../validation/login';
import Button from '../button/Button';
import Input from '../input/Input';

const Login: React.FC<{ from: string }> = ({ from }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isLoading = useAppSelector(state => state.prop.isLoading);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<LoginData>({
    resolver: yupResolver(loginSchema)
  });

  const onSubmit = async (data: LoginData) => {
    await withErrorHandler(async () => {
      await dispatch(loginPropThunk(data)).unwrap();
      navigate(from, { replace: true });
    });
  };
  const commonProps = {
    register,
    errors,
    required: true,
    className: `bg-gray-200 h-[35px] rounded-md px-2 font-medium text-black`
  };

  return (
    <form className="flex flex-col mt-3" onSubmit={handleSubmit(onSubmit)}>
      <Input type="email" placeholder="Enter Your Email" name="email" {...commonProps} />
      <Input type="password" placeholder="Enter Your Password" name="password" {...commonProps} />
      <Button
        type="submit"
        className="bg-[#35e0a1] mt-6 h-[35px] rounded-md font-medium"
        label="Login"
        isLoading={isLoading[loginPropThunk.pending.toString()]}
      />
    </form>
  );
};

export default Login;
